import { ApplicationState } from '../../../../store/types';
import { OpinionScope } from '../../../admin/opinions/store/types';
import { ColumnSort, TableFilters } from '../../../shared/table/types';
import { getOpinionAnalyticsRoot } from '../../store/selectors';
import { ExtensiveOpinionAverage, OpinionAnalyticsChart, OpinionAverage, OpinionAverageView, OpinionCoverageAnalytics, OpinionMapAnalytics, OpinionSingleField } from './types';
import { filterAndSortOpinionsWithAverage, getDefaultSingleFieldForScope } from './utils';

export const getFetchingAnalytics = (state: ApplicationState): OpinionAnalyticsChart[] => getOpinionAnalyticsRoot(state).fetchingAnalytics;

export const getTileInView = (state: ApplicationState): OpinionAnalyticsChart | null => getOpinionAnalyticsRoot(state).tileInView;

export const getSingleDataPointMapAnalytics = (state: ApplicationState): OpinionMapAnalytics[] => getOpinionAnalyticsRoot(state).singleDataPointMapAnalytics;

export const getJurisdictionCoverageMapAnalytics = (state: ApplicationState): OpinionCoverageAnalytics[] => getOpinionAnalyticsRoot(state).jurisdictionCoverageMapAnalytics;

export const getOpinionAnalyticsScope = (state: ApplicationState): OpinionScope => getOpinionAnalyticsRoot(state).scope;

export const getOpinionSingleField = (state: ApplicationState): OpinionSingleField => getOpinionAnalyticsRoot(state).singleField;

export const getSingleDataPointSelectedCountry = (state: ApplicationState): string | null => getOpinionAnalyticsRoot(state).singleDataPointSelectedCountry;

export const getJurisdictionCoverageSelectedCountry = (state: ApplicationState): string | null => getOpinionAnalyticsRoot(state).jurisdictionCoverageSelectedCountry;

export const getSelectedSingleFieldJurisdiction = (state: ApplicationState): string | null => getOpinionAnalyticsRoot(state).inspectedSingleFieldJurisdiction;

export const getAllOpinionsWithAverage = (state: ApplicationState): OpinionAverage[] => getOpinionAnalyticsRoot(state).opinionsWithAverage;

export const getOpinionAverageFilters = (state: ApplicationState): TableFilters => getOpinionAnalyticsRoot(state).opinionAverageTableFilters;
export const getOpinionAverageColumnSort = (state: ApplicationState): ColumnSort | undefined => getOpinionAnalyticsRoot(state).opinionAverageTableSort;

export const getOpinionsWithAverage = (state: ApplicationState): OpinionAverage[] => {
    const opinionsWithAverage = getAllOpinionsWithAverage(state);
    if (opinionsWithAverage.length > 0) {
        const filters = getOpinionAverageFilters(state);
        const sort = getOpinionAverageColumnSort(state);
        const filteredOpinions = filterAndSortOpinionsWithAverage(opinionsWithAverage, filters, sort);
        return filteredOpinions;
    }
    return opinionsWithAverage;
};

export const getTotalOpinionAverage = (state: ApplicationState): number => {
    const opinionsWithAverage = getOpinionsWithAverage(state);
    const rawTotal = opinionsWithAverage.reduce((acc, cur) => acc + cur.average, 0) / opinionsWithAverage.length || 0;
    const total = Math.round(rawTotal * 100) / 100;
    return total;
};

export const getOpinionAverageView = (state: ApplicationState): OpinionAverageView => getOpinionAnalyticsRoot(state).opinionAverageView;

export const getIsFetchingOpinionAverageBreakdown = (state: ApplicationState): boolean => getOpinionAnalyticsRoot(state).fetchingOpinionAverageBreakdown;

export const getSelectedOpinionAverage = (state: ApplicationState): ExtensiveOpinionAverage | null => getOpinionAnalyticsRoot(state).selectedOpinionWithAverage;

export const getUltimateSingleFieldForScope = (state: ApplicationState): OpinionSingleField => getDefaultSingleFieldForScope(getOpinionAnalyticsScope(state));

export const getViewSignOffAnswers = (state: ApplicationState): boolean => getOpinionAnalyticsRoot(state).viewSignOffAnswers;

export const getSelectedCounterpartyCoverage = (state: ApplicationState): string | null => getOpinionAnalyticsRoot(state).counterpartyCoverage;

export const getSelectedTransactionCoverage = (state: ApplicationState): string | null => getOpinionAnalyticsRoot(state).transactionCoverage;

export const getSelectedCoverageJurisdiction = (state: ApplicationState): string | null => getOpinionAnalyticsRoot(state).inspectedCoverageJurisdiction;
